import { onValue, ref } from 'firebase/database';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useContext, useEffect, useState } from 'react';

export function useMatchDayResults({ currentSeason_info }) {

  const parentContext = useContext(ParentContext);

  const { states } = parentContext ?? {};
  const { app_state, paps_state } = states ?? {};
  const { pathViews } = paps_state ?? {};
  const { app_ts } = app_state ?? {};
  const { latestSeason } = currentSeason_info ?? {}

  const [matchDayResults, setMatchDayResults] = useState({});

  // const path_sport = `clients/${pathViews.clients}/events/${pathViews.events}/matchDayResults/${pathViews.sports}`;

  // const { data, loading } = useRtdbListener(
  //   app_ts?.realtime,
  //   app_ts?.app,
  //   path_sport,
  //   {
  //     initialValue: {},
  //     transform: (v) => v || {},
  //   }
  // );

  useEffect(() => {

    if (!app_ts?.realtime || !latestSeason || !pathViews?.sports) return
    const path_sport = getMatchPath(pathViews, latestSeason)

    // const path_sport = `clients/${pathViews.clients}/events/${pathViews.events}/matchDayResults/${pathViews.sports}`;

    // console.log('path_sport', path_sport)
    // console.log('DB APP:', app_ts?.realtime);

    const _ref = ref(app_ts.realtime, path_sport);


    onValue(_ref, (snapshot) => {
      const mdrs = snapshot.val()
      console.log('⚡matchDayResults ⚡', mdrs)
      setMatchDayResults(mdrs);
    });

    // LIVE listener
    // onValue(_ref, handleValue);

    // cleanup
    // return () => {
    //   off(_ref, 'value', handleValue);
    // };

  }, [pathViews?.sports, latestSeason]);

  return { matchDayResults };
}

const getMatchPath = (pathViews, latestSeason,) => {
  const path = `clients/${pathViews.clients}/events/${pathViews.events}/sports/${pathViews.sports}/matchDayResults/${latestSeason}/`
  return path
}